if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet && !this.openDefault && this.isOpen) {
        // Closed on load without the accordion animation: it measures the heights, which forced a reflow.
        this.isOpen = false;
        this.removeAttribute('open');
        this.parentElement.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}